import { get } from '../base-portal-api';

import { MerchantsResponse } from './types';

export function getMerchant() {
  return get('v1/merchants').json<MerchantsResponse>();
}
